// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app {\n  font-family: \"Quicksand\", Graphik-Medium, Graphik-Regular, \"Gotham SSm A\", \"Gotham SSm B\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #2c3e50;\n}\n#nav {\n  padding: 5px;\n  background: #fff;\n}\n#nav a {\n  font-weight: bold;\n  color: #044280;\n}\n#nav a.router-link-exact-active {\n  color: #044280;\n}\n.form {\n  background: #fff;\n  min-height: 100vh;\n}", ""]);
// Exports
module.exports = exports;
